import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';

import { AudioMessageFiles } from './components/audioMessageFiles/audioMessageFiles';
import { WaitMusicFiles } from './components/waitMusicFiles/waitMusicFiles';

export const SettingsAudioView = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState('announcement');

  const handleTabChange = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);

  return (
    <Page>
      <Page.Head title="Audio files" />

      <Page.Tabs>
        <Tabs
          selectedId={activeTab}
          tabs={[
            { id: 'announcement', label: 'Announcement' },
            { id: 'wait-music', label: 'Wait music' },
          ]}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        {activeTab === 'announcement' && <AudioMessageFiles />}
        {activeTab === 'wait-music' && <WaitMusicFiles />}
      </Page.Body>
    </Page>
  );
};
